import { render, staticRenderFns } from "./NflProjection.vue?vue&type=template&id=13814b4c&scoped=true"
import script from "./NflProjection.vue?vue&type=script&lang=js"
export * from "./NflProjection.vue?vue&type=script&lang=js"
import style0 from "./NflProjection.vue?vue&type=style&index=0&id=13814b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13814b4c",
  null
  
)

export default component.exports